import { render, staticRenderFns } from "./BotsList.vue?vue&type=template&id=eadf54d0&scoped=true"
import script from "./BotsList.vue?vue&type=script&lang=js"
export * from "./BotsList.vue?vue&type=script&lang=js"
import style0 from "./BotsList.vue?vue&type=style&index=0&id=eadf54d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eadf54d0",
  null
  
)

export default component.exports